import get from 'transmute/get';
import { checkIsRoutingRuleConfig } from '../operators/routingRulesGetters';
export const getAssignByAvailability = routingRules => {
  let assignByAvailability = false;
  if (checkIsRoutingRuleConfig(routingRules)) {
    assignByAvailability = Boolean(get('shouldFilterToAvailable', routingRules));
  }
  return assignByAvailability;
};